import "./assets/style/reset.css"
import "./assets/style/common.css"
import "./assets/style/iconfont/iconfont.css"
import "element-ui/lib/theme-chalk/index.css"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
// 引入font.css
import "./assets/style/font.css"

import Vue from "vue"

import App from "./App.vue"
import router from "./router"
import store from "./store"
import Router from "vue-router"
import ElementUI from "element-ui"
import Axios from "axios"
import qs from "qs"
import * as echarts from "echarts"
// import { quillEditor } from 'vue-quill-editor'
import VueQuillEditor from "vue-quill-editor"

const { urlUser, urlCommon, baseURL } = require('./config/env.' + process.env.NODE_ENV)

Axios.defaults.baseURL = baseURL
Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$qs = qs
Vue.prototype.$echarts = echarts

Vue.prototype.urlCommon = urlCommon
Vue.prototype.urlUser = urlUser
// Vue.prototype.urlUser = "http://patent.tianjin.parkip.cn"// 线上地址-企业版
// Vue.prototype.urlCommon = "http://192.168.2.189:9995/"// 打包时放开-保税平台

// Vue.prototype.urlCommon = ''

Vue.prototype.logoutHref = "/logout"

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(ElementUI)
// 富文本编辑器
Vue.use(VueQuillEditor)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app")
